import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || submitting) return;
    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      await fetch("https://readdy.ai/api/form/d8s0lb3f81iibef4bip0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      // silently handle
    }
    setSubmitting(false);
  };

  return (
    <footer className="bg-accent-900" id="footer">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Left Column - Stay Updated */}
          <div className="md:col-span-5">
            <h4 className="text-2xl md:text-3xl font-heading font-light text-white mb-3">
              Stay Updated
            </h4>
            <p className="text-sm text-accent-200 mb-6 leading-relaxed max-w-sm">
              Get the latest OOPBuy spreadsheet insights and product research tips delivered to your inbox. No spam, just valuable data.
            </p>
            {submitted ? (
              <p className="text-sm text-accent-200 font-medium">
                Thank you for subscribing! We will keep you updated.
              </p>
            ) : (
              <form
                onSubmit={handleSubmit}
                data-readdy-form=""
                className="flex flex-col sm:flex-row gap-3 max-w-sm"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="flex-1 bg-transparent border-b border-accent-500/50 text-white text-sm py-2 px-1 outline-none placeholder:text-accent-400/60 focus:border-accent-300 transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-6 py-2 rounded-full bg-white text-accent-900 text-sm font-medium hover:bg-accent-50 transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  Subscribe
                </button>
              </form>
            )}
          </div>

          {/* Middle Column - Quick Links */}
          <div className="md:col-span-3">
            <h5 className="text-xs font-semibold uppercase tracking-wider text-accent-300 mb-4">
              Quick Links
            </h5>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/oopbuy-spreadsheet-guide"
                  className="text-sm text-accent-200 hover:text-white transition-colors underline underline-offset-4"
                >
                  OOPBuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-accent-200 hover:text-white transition-colors underline underline-offset-4 whitespace-nowrap"
                >
                  Main Website &rarr;
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-accent-200 hover:text-white transition-colors underline underline-offset-4 whitespace-nowrap"
                >
                  Buy It Now &rarr;
                </a>
              </li>
              <li>
                <a
                  href="#categories"
                  className="text-sm text-accent-200 hover:text-white transition-colors underline underline-offset-4"
                >
                  All Categories
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column - Contact & Legal */}
          <div className="md:col-span-4">
            <h5 className="text-xs font-semibold uppercase tracking-wider text-accent-300 mb-4">
              Contact
            </h5>
            <p className="text-sm text-accent-200 mb-1">
              <a href="mailto:support@oopbuyspreadsheets.lat" className="hover:text-white transition-colors">
                support@oopbuyspreadsheets.lat
              </a>
            </p>
            <p className="text-sm text-accent-200 mb-6">
              Visit our main platform for full product database access.
            </p>
            <p className="text-xs text-accent-400/70 leading-relaxed">
              This website provides informational spreadsheet data only. We do not directly sell or ship any products. Data is for research and educational use only.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-accent-600/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-accent-300 hover:text-white transition-colors underline underline-offset-4">
                Twitter
              </a>
              <a href="#" className="text-sm text-accent-300 hover:text-white transition-colors underline underline-offset-4">
                LinkedIn
              </a>
              <a href="#" className="text-sm text-accent-300 hover:text-white transition-colors underline underline-offset-4">
                Instagram
              </a>
            </div>
            <p className="text-xs text-accent-400/60">
              &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-accent-400/60 hover:text-accent-300 transition-colors whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="#" className="text-xs text-accent-400/60 hover:text-accent-300 transition-colors whitespace-nowrap">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}